<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="TableColumnType.Order">
    {{ (index ?? 0) + 1 }}
  </ng-container>
  <ng-container *ngSwitchCase="TableColumnType.Basic">
    <div class="column-cell">
      <div class="column-cell-content">
        <ui-text
          class="column-cell-content-value"
          [text]="data | propertyValue : name"
          [ellipsisRows]="2"
        ></ui-text>
        <ui-text
          *ngIf="subName"
          class="column-cell-content-sub-value"
          [text]="data | propertyValue : subName"
          [ellipsisRows]="2"
        ></ui-text>
      </div>
    </div>
  </ng-container>

  <ui-table-body-custom-column
    *ngSwitchCase="TableColumnType.Custom"
    [config]="config"
    [data]="data"
    (updateTableData)="onUpdateTableData()"
  >
  </ui-table-body-custom-column>
  <ui-table-body-actions-column
    *ngSwitchCase="TableColumnType.Actions"
    [config]="config"
    [data]="data"
    (updateTableData)="onUpdateTableData()"
    (actionClicked)="onActionClicked($event)"
  >
  </ui-table-body-actions-column>
</ng-container>
